module.exports = {"421088100":"容城镇","421088101":"朱河镇","421088102":"新沟镇","421088103":"龚场镇","421088104":"周老嘴镇","421088105":"黄歇口镇","421088106":"汪桥镇","421088107":"程集镇","421088108":"分盐镇","421088109":"毛市镇","421088110":"福田寺镇","421088111":"上车湾镇","421088112":"汴河镇","421088113":"尺八镇","421088114":"白螺镇","421088115":"网市镇","421088116":"三洲镇","421088117":"桥市镇","421088200":"红城乡","421088201":"棋盘乡","421088202":"柘木乡","421088450":"人民大垸农场管理区","421088451":"荒湖农场管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421088.json
// module id = 1895
// module chunks = 0